import FormLink from './FormLink'
import ListOut from '@components/shared/ListOut'

const FormLinks = ({ show = true, links, LinkItem = FormLink, ...rest }) => {
    if (!show) return null
    return <ListOut id="t" items={links} Component={FormLink} {...rest} />
}

export default FormLinks